<template>
  <div
    class="card product-teaser"
    :class="compact ? 'compact' : 'extended'"
    @click="$emit('click')"
  >
    <div
      :style="`background-image: url(https://shop.mitemma.de/img/products/${product.img}_1200.jpg)`"
      class="card-img-top product-img"
      alt="..."
    />
    <div class="card-body">
      <h4 class="card-title product-title">{{ product.brandName }} {{ product.label }}</h4>
      <p class="card-text product-size">{{ product.packageSize }} {{ product.packageUnit }}</p>
      <br />
      <span
        class="badge badge-pill amount"
        v-if="amount"
        :class="amount.total > amount.current ? 'badge-warning' : 'badge-success'"
      >{{amount.current}} / {{amount.total}}</span>
      <button class="btn btn-primary" v-if="stockInOption" @click="$emit('stockIn')">Einlagern</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['amount', 'product', 'stockInOption', 'compact']
}
</script>

<style lang="scss" scoped>
.product-teaser {
  flex-direction: row;
  align-items: center;

  &.compact {
    .product-img {
      width: 8rem;
      height: 8rem;
      margin: 0.5rem;
    }

    .card-body {
      padding: 0.5rem;
    }

    .amount {
      display: inline-block;
      margin: 0.5rem 0 0;
      font-size: 1rem;
    }

    .product-title {
      font-size: 20px;
      margin: 0;
      display: inline;
    }
    .product-size {
      display: inline;
      &:before {
        content: ', ';
      }
    }
  }
}

.product-img {
  width: 16rem;
  height: 16rem;
  margin: 1rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
@media (max-width: 40rem) {
  .product-teaser {
    &.extended {
      flex-direction: column;

      .product-img {
        width: 8rem;
        height: 8rem;
        margin: 0.5rem 0 -0.5rem;
      }
    }

    &.compact {
      .product-img {
        width: 4rem;
        height: 4rem;
      }

      .product-title {
        font-size: 16px;
      }

      .amount {
        font-size: 0.75rem;
      }
    }
  }
}
</style>
